<script setup lang="ts">
import {ref} from "vue";
const fonts = ref([
    "Agreloy", "Algerian", "AgreloyOut1", "AgreloyS1", "Amity Jack",
    "American Captain", "Antilles", "Antilles Expanded", "Antilles Laser", "Antilles Condensed",
    "Antilles Academy", "Avengeance Heroic Avenger", "BadaBoom BB", "Babycakes", "Berlin Sans FB",
    "Britannic", "Bernard MT Condensed", "BubbleGum", "Casual Tossed", "Chunky Funks", "CF Revolution",
    "Chardons_PersonalUseOnly", "Casual", "Cheeseburger", "Comic Sans MS", "Cookies", "Clarendon",
    "Curlz MT", "Discoteca Rounded", "Cooper", "Copperplate Gothic", "Dutch801 XBd BT",
    "DEATHE MAACH NCV", "Dutch801 Rm BT", "Eras Bold ITC", "Ebrima", "Franklin Gothic", "Foo",
    "Franklin Gothic Demi Cond", "Futura Hv BT", "Freshman", "Geometos Rounded", "GMV DIN Pro Cond",
    "Gorgeous Girls", "Good Times Rg", "Century Gothic", "Goudy Stout", "Great Lakes NF", "Impact",
    "Janda Curlygirl Chunky", "Janda Curlygirl Pop", "Janda Manatee Solid", "Janda Manatee Bubble",
    "Janda Curlygirl Serif", "Kids Zone", "Komika Boogie", "Lemondrop", "Kimberley Bl", "Magic Sound",
    "Marker Felt", "Matias", "Montserrat", "PAGI JAKARTA", "Pussycat", "Piparivahtiperhonen Itio",
    "Noteworthy", "Raider Crusader", "Piparivahtiperhonen", "Raider Crusader Chrome",
    "Raider Crusader 3D", "Raider Crusader Bevel", "Raider Crusader Expanded", "Raider Crusader Laser",
    "Raider Crusader Gradient", "Raider Crusader Engraved", "Raider Crusader Condensed",
    "Raider Crusader Halftone", "Raider Crusader Shift Down", "Raider Crusader Leftalic",
    "Raider Crusader Shift Up", "Raider Crusader Straight", "Raider Crusader Punch",
    "Raider Crusader Title", "Raider Crusader Outline", "Raider Crusader Rotalic",
    "Raider Crusader Semi-Straight", "Skater Girls Rock", "Roboto Condensed", "Super Mario 256",
    "Skaters", "Supersonic Rocketship", "SVN-Coco FY", "SVN-Zero", "UTM Banque",
    "UTM Pacific Standard", "SVN-A Love Of Thunder", "UTM Staccato", "UTM Rockwell"
]);

const model = defineModel();
const emit = defineEmits(["change"]);

const props = defineProps(["text"]);

const isShowListFont = ref(false);

const selectFont = (font: string)=>{
    model.value = font;
    isShowListFont.value = false;
    emit("change", model.value);
}

</script>

<template>
    <div c2c-0 class="fs-20 bd-w:1-c:1-s:sl-l:50 bg-yellow-l:20 br-6 h-40 rm rw p-12 sd" :style="{fontFamily: <string>model}" @click="isShowListFont = true">
        <span>{{model}}</span>
        <span c2c-1 class="icon-down-open-mini"></span>
    </div>
    <div v-if="isShowListFont" c2c-2 class="absolute t-0 l-0 bg-0 w-100% z-100000000">
        <div c2c-3 class="rw rm bg-yellow-l:20 w-100% p-7">
            <div>Select a font</div>
            <span c2c-4 class="icon-cancel" @click="isShowListFont = false"></span>
        </div>
        <ul c2c-5 class="list-font p-b-150">
            <li v-for="f in fonts">
                <p c2c-6 class="p-12 w-100% fs-19 cur-1 bd-b tc"
                   :class="{current: f === model}"
                   :style="{fontFamily: f}"
                   @click="selectFont(f)">{{text ? text : f}}</p>
            </li>
        </ul>
    </div>

</template>

<style scoped>

.list-font {
    .current {
        background-color: #5dffaf;
    }
}


</style><style lang="scss" scoped>.fs-20[c2c-0] {
                        font-size: 20px;
                 }.bd-w\:1-c\:1-s\:sl-l\:50[c2c-0] {
                        border-top-width: 1px;border-top-style: solid;border-top-color: hsl(0, 0%, 50%);border-right-width: 1px;border-right-style: solid;border-right-color: hsl(0, 0%, 50%);border-bottom-width: 1px;border-bottom-style: solid;border-bottom-color: hsl(0, 0%, 50%);border-left-width: 1px;border-left-style: solid;border-left-color: hsl(0, 0%, 50%);
                 }.bg-yellow-l\:20[c2c-0] {
                        background-color: hsl(60, 100%, 70%);
                 }.br-6[c2c-0] {
                        border-top-left-radius: 6px;border-top-right-radius: 6px;border-bottom-right-radius: 6px;border-bottom-left-radius: 6px;
                 }.h-40[c2c-0] {
                        height: 40px;
                 }.rm[c2c-0] {
                        display: flex; flex-direction: row; align-items: center;
                 }.rw[c2c-0] {
                        display: flex; flex-direction: row; justify-content: space-between;
                 }.p-12[c2c-0] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.sd[c2c-0] {
                        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.2)
                 }.absolute[c2c-2] {
                        position: absolute;
                 }.t-0[c2c-2] {
                        
            top: 0;
        
                 }.l-0[c2c-2] {
                        
            left: 0;
        
                 }.bg-0[c2c-2] {
                        background-color: hsl(0, 0%, 100%);
                 }.w-100\%[c2c-2] {
                        width: 100%;
                 }.z-100000000[c2c-2] {
                        z-index: 100000000;
                 }.rw[c2c-3] {
                        display: flex; flex-direction: row; justify-content: space-between;
                 }.rm[c2c-3] {
                        display: flex; flex-direction: row; align-items: center;
                 }.bg-yellow-l\:20[c2c-3] {
                        background-color: hsl(60, 100%, 70%);
                 }.w-100\%[c2c-3] {
                        width: 100%;
                 }.p-7[c2c-3] {
                        padding-top: 7px;padding-right: 7px;padding-bottom: 7px;padding-left: 7px;
                 }.p-b-150[c2c-5] {
                        padding-bottom: 150px;
                 }.p-12[c2c-6] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.w-100\%[c2c-6] {
                        width: 100%;
                 }.fs-19[c2c-6] {
                        font-size: 19px;
                 }.cur-1[c2c-6] {
                        cursor: pointer;
                 }.bd-b[c2c-6] {
                        border-bottom-width: 1px;border-bottom-style: solid;border-bottom-color: hsla(0, 0%, 72.5%, 0.7);
                 }.tc[c2c-6] {
                        text-align: center;
                 }</style>